import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  OnChanges, SimpleChanges,
  OnDestroy
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Api } from '../../services/api';
import { LoaderService } from '../../services/loader';
// import { ErrorService } from '../../services/error.service';
import { Subscription } from 'rxjs';
import { Toaster } from '../../services/toaster';
import { Auth } from '../../services/auth';
@Component({
  selector: 'app-risk-officer-confirm-popup',
  imports: [CommonModule, TooltipModule],
  templateUrl: './risk-officer-confirm-popup.html',
  styleUrl: './risk-officer-confirm-popup.scss',
})
export class RiskOfficerConfirmPopup implements OnInit, OnChanges, OnDestroy {
  @Input() riskIcon!: string;
  @Input() risks: any;
  // @Input() modalRef!: BsModalRef;
  @Input() readOnlyRisk: any;
  @Input() selectedFrequencyData: any = '';
  @Input() selectedPflmIdData: any = '';

  @Output() closePopup = new EventEmitter<void>(); // EventEmitter for closing
  @ViewChildren('checkbox') checkboxes!: QueryList<ElementRef>;
  uncheckedRisks: any;
  selectedRisks: any[] = [];
  isDisabled = true;
  cancelRisksList = [] as any;
  retainableRisk: { IssueId: number; RetainOrClose: string }[] = []; 
  noDataImg = 'assets/images/nodata.svg';
  reviewerID = 0;
  userDetails: any = {};
  isDualApiMode = false;

  private subscription: any = [];
  constructor(
    public apiService: Api,
    private toasterService: Toaster,
    private authService: Auth,
    private loaderService: LoaderService
  ) { }

  // 🔑 Added ngOnChanges to instantly capture live checkbox modifications from Notes parent
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['risks'] || changes['readOnlyRisk']) {
      const riskList = this.risks ?? [];
      this.uncheckedRisks = riskList.filter((item: any) => {
        return !this.readOnlyRisk.includes(+item.IssueId);
      });
      
      if (riskList.length > 0 && this.readOnlyRisk?.length > 0) {
        this.selectedRisks = riskList.filter((risk: any) =>
          this.readOnlyRisk.includes(+risk.IssueId)
        );
      } else {
        this.selectedRisks = [];
      }
      
      this.cancelRisksList = []; 
      this.retainableRisk = this.uncheckedRisks.map((issue: any) => ({
        IssueId: issue.IssueId,
        RetainOrClose: 'Retain',
      }));
    }
  }

  ngOnInit(): void {
    this.userDetails = this.authService.getUserDetails();
    this.reviewerID = this.userDetails.eid || 0;
    const riskList = this.risks ?? [];
    this.uncheckedRisks = riskList.filter((item: any) => {
      return !this.readOnlyRisk.includes(+item.IssueId);
    });
    // Filter the full list of risks to get only the objects for the checked risks
    if (riskList.length > 0 && this.readOnlyRisk?.length > 0) {
      this.selectedRisks = riskList.filter((risk: any) =>
        this.readOnlyRisk.includes(+risk.IssueId)
      );
    }
    this.cancelRisksList = []; // by default cancelRisksList is set to empty
    //By default when risk confirm popup opens all the unchecked risks are kept Retain
    this.retainableRisk = this.uncheckedRisks.map((issue: any) => ({
      IssueId: issue.IssueId,
      RetainOrClose: 'Retain',
    }));
  }
  ngOnDestroy(): void {
    let subscription: Subscription;
    if (this.subscription?.length)
      for (subscription of this.subscription) {
        subscription.unsubscribe();
      }
  }
  /**
   * Close modal
   */
  closeModal() {
    this.closePopup.emit(); // Emit the event to close the popup
    //call to update issue list i.e refresth the issue-listsr component.
    // this.apiService.sendData({ type: 'refresh-originalData' });
  }
  /**
   * Check form is valid or not
   * @returns
   */
  isValid(): boolean {
    let temp;
    const checkboxData = !this.checkboxes ? [] : this.checkboxes;
    return (temp = checkboxData.some((item) => item.nativeElement.checked));
  }

  handleRiskAction(riskId: number, action: string): void {
    // Update retainableRisk array
    const existingRiskIndex = this.retainableRisk.findIndex(
      (risk) => risk.IssueId === riskId
    );

    if (existingRiskIndex > -1) {
      // Update the action if the risk already exists
      this.retainableRisk[existingRiskIndex].RetainOrClose =
        action === 'cancel' ? 'Close' : 'Retain';
    } else {
      // Add the risk if it doesn't exist
      this.retainableRisk.push({
        IssueId: riskId,
        RetainOrClose: action === 'cancel' ? 'Close' : 'Retain',
      });
    }

    // we are still using cancelRisksList for internally maintaining the state of checkbox
    if (action === 'cancel') {
      if (!this.cancelRisksList.includes(riskId)) {
        this.cancelRisksList.push(riskId); // Add to cancelRisksList
      }
    } else if (action === 'keep') {
      const index = this.cancelRisksList.indexOf(riskId);
      if (index > -1) {
        this.cancelRisksList.splice(index, 1); // Remove from cancelRisksList
      }
    }


  }

  // new method that uses retainable data
  submitRisksToCancelAtFlm(): void {
    const payload = {
      IssueLst: this.retainableRisk, // Use retainableRisk directly as the new IssueLst
      AssociateId: this.reviewerID.toString(), // Associate ID
    };
    this.loaderService.show();
    // pointing to new api method that will retain the risks open or cancel
    this.subscription['GenAIUpdateIssueStatusRetention'] = this.apiService
      .GenAIUpdateIssueStatusRetention(payload)
      .subscribe({
        next: (response) => {
          this.loaderService.hide();
          this.closeModal();

          // this.toasterService.setError({
          //   message: 'Issue(s) successufully updated in DHD FLM. You may close the window',
          //   type: 'info',
          // });
          // Dynamic message based on combined scenario or single scenario
          const successMessage = this.isDualApiMode
            ? "Issue(s) successfully updated in DHD FLM. Risk(s) successfully logged in the Risk Register. You may close the window."
            : "Issue(s) successufully updated in DHD FLM. You may close the window";

          this.toasterService.setError({
            message: successMessage,
            type: this.isDualApiMode ? 'success' : 'info', // Using success type for combined confirmations
          });
          // this.appService.sendData({ type: 'close-notes' });
          this.apiService.openNotes({
            open: false,
            data: null
          });
        },
        error: (e: any) => {
          this.loaderService.hide();
          const error = e?.message || e?.statusText;
          console.log('Error: ' + error);

          // this.toasterService.setError({
          //   message: 'Failed to update issue(s) in DHD FLM . Please try again',
          //   type: 'error',
          // });

          // Dynamic message based on combined scenario or single scenario
          const failureMessage = this.isDualApiMode
            ? "Risk(s) successfully logged in the Risk Register. Failed to update issue(s) in DHD FLM. Please try again"
            : "Failed to update issue(s) in DHD FLM . Please try again";

          this.toasterService.setError({
            message: failureMessage,
            type: 'error',
          });
          this.loaderService.hide();
          this.closeModal();
        },
        complete: () => {
          this.apiService.triggerRefresh();
        }
      });
  }

  // // Once risk officer clicks on submit on the drawer this method should be called
  riskOfficerSubmit() {
    this.toasterService.clearAll();
    // Set the tracking flag if both lists have items
    this.isDualApiMode = this.selectedRisks.length > 0 && this.uncheckedRisks.length > 0;
    if (this.selectedRisks.length > 0) { // If checked risks are present then save to risk register
      this.saveRiskInRiskRegister();
    }
    else if (this.uncheckedRisks.length > 0) { // if only unchecked risks are present then close them as flm level
      this.submitRisksToCancelAtFlm();
    }
    else { // just close the modal if no risks are present at all
      this.closeModal();
    }
  }

  /**
 * Calling api to save risk in risk register
 */
  saveRiskInRiskRegister(): void {
    this.loaderService.show();
    // const RiskLst = this.selectedRisks;
    // Create a new list from selectedRisks, ensuring IsRisk is set to true for the payload.

    const toPrimeItem = (risk: any) => {
      const {
        IssueId: PulseAgent_IssueId,
        IssueStatusId: RiskStatus,
      } = risk ?? {};

      return {
        PulseAgent_IssueId: Number(PulseAgent_IssueId ?? 0),
        RiskStatus: Number(RiskStatus ?? 0),
      };
    };

    const RiskLst = (this.selectedRisks ?? [])
      .map(toPrimeItem)
      .filter(item => item.PulseAgent_IssueId && item.RiskStatus);

    if (RiskLst?.length) {
      const payload = {
        RiskLst,
        UserRole: "RISKOFFICER",
        AssociateId: this.reviewerID.toString(),
      };
      this.subscription['GenAIInsertIntoRiskRegister'] = this.apiService.GenAIInsertIntoRiskRegister(payload).subscribe({
        next: (data: any) => {
          this.loaderService.hide();
          // if (this.selectedRisks.length > 0) {
          //   this.toasterService.setError({
          //     message: 'Risk(s) successfully logged in the Risk Register. You may close the window',
          //     type: 'success',
          //   });
          // }
          // ONLY show this standalone toaster if we are NOT in a dual API scenario
          if (!this.isDualApiMode && this.selectedRisks.length > 0) {
            this.toasterService.setError({
              message: 'Risk(s) successfully logged in the Risk Register. You may close the window',
              type: 'success',
            });
          }
          // //if readonly risk is length is not equal to total risks then open modal
          // if (this.readOnlyRisk.length !== this.risks.length) {
          //   this.modal = this.modalService.show(template);
          // }
          if (this.uncheckedRisks.length > 0) {
            this.submitRisksToCancelAtFlm(); // if unchecked risks are present then we call this API
          }
          else {
            this.closeModal();
          }
          this.loaderService.hide();
          this.apiService.openNotes({
            open: false,
            data: null
          });
          //refresh the data
          // this.appService.sendData({
          //   type: 'refresh-originalData',
          //   frequency: this.selectedFrequencyData,
          // });
        },
        error: (e: any) => {
          this.loaderService.hide();
          const error = e?.message || e?.statusText;
          console.log('Error: ' + error);
          this.toasterService.setError({
            message: 'Failed to log risk(s) in the Risk Register. Please try again.',
            type: 'error',
          });
        },
        complete: () => {
          this.apiService.triggerRefresh();
        }
      });
    } else {
      this.apiService.openNotes({
        open: false,
        data: null
      });
      // this.modal = this.modalService.show(template);
      this.loaderService.hide();
    }
  }
}
